import { useState } from 'react';

import { YStack } from '@/components/ui/layout/layout';
import TextArea from '@/components/ui/TextArea';

import { SectionHeading } from '../components/section-heading';

import { useSaveUserNotesMutation } from './edits.query';

export const UserNotesEditor = ({
  personId,
  savedNotes,
}: {
  personId: string;
  savedNotes: string;
}) => {
  const [draft, setDraft] = useState(savedNotes);
  const [baseline, setBaseline] = useState(savedNotes);
  if (savedNotes !== baseline) {
    // Notes changed underneath us (another device, a merge, or our own save landing in the cache)
    // Follow them unless the user has an unsaved edit
    setBaseline(savedNotes);
    if (draft === baseline) setDraft(savedNotes);
  }
  const { mutate: saveNotes, isPending } = useSaveUserNotesMutation(personId);

  return (
    <YStack className="items-start gap-3">
      <SectionHeading title="Your notes" />
      <TextArea
        rows={3}
        maxLength={10_000}
        value={draft}
        placeholder="Add a note…"
        className="min-h-[5.5rem] resize-none rounded-lg border-0 bg-surface px-3 py-2 text-sm leading-6 shadow-none transition-colors [field-sizing:content] placeholder:text-foreground-subtle hover:bg-surface-hover focus-visible:border-0"
        onChange={(event) => setDraft(event.target.value)}
        onBlur={() => draft !== savedNotes && saveNotes(draft)}
      />
      {isPending && (
        <span className="text-xs text-foreground-subtle">Saving…</span>
      )}
    </YStack>
  );
};
